import React from "react";
import LegalPage from "./LegalPage";
import { SITE } from "@/lib/site";

export default function Terms() {
  return (
    <LegalPage
      path="/terms"
      heading="Terms & Conditions"
      updated="September 2026"
      title="Terms & Conditions | Registry Feed"
      description="The terms and conditions governing your use of Registry Feed's website, dashboard and data products."
    >
      <p>These Terms &amp; Conditions govern your use of Registry Feed (the "Service"). By registering, subscribing or otherwise using the Service, you agree to these terms.</p>
      <h2>1. Service description</h2>
      <p>Registry Feed provides subscribers with datasets of newly registered companies in India — compiled from public MCA and GSTN filings — delivered as daily CSV files through a subscriber dashboard.</p>
      <h2>2. Eligibility</h2>
      <p>You must be at least 18 years old, and you must have the authority to bind the business on whose behalf you subscribe.</p>
      <h2>3. Account &amp; approval</h2>
      <p>All subscriptions require approval by Registry Feed. We may reject or terminate any account at our discretion, including for suspected misuse.</p>
      <h2>4. Subscription &amp; payment</h2>
      <ul>
        <li>Subscriptions are for a fixed 30-day window unless a different duration is agreed in writing.</li>
        <li>Payment is handled outside the platform — details are shared over WhatsApp.</li>
        <li>Renewals or extensions must be requested before or after expiry and are subject to fresh payment.</li>
      </ul>
      <h2>5. Data use restrictions</h2>
      <p>You may use the data for legitimate B2B outreach, research and analysis. You may <strong>not</strong>:</p>
      <ul>
        <li>Resell, sublicense, publish, or redistribute Registry Feed datasets in whole or in part.</li>
        <li>Use the data for any purpose that violates Indian law, including the Information Technology Act, TRAI regulations, or spam rules.</li>
        <li>Attempt to reverse-engineer, scrape, or bulk-export beyond the reasonable limits of your dashboard.</li>
      </ul>
      <p>Detailed rules are in our <a href="/acceptable-use">Acceptable Use Policy</a>.</p>
      <h2>6. Intellectual property</h2>
      <p>The Registry Feed platform, branding, dashboard software and data compilations are our intellectual property. You get a limited, non-exclusive, non-transferable licence to use them for the duration of your paid subscription.</p>
      <h2>7. No guarantees</h2>
      <p>The data is provided "as is". We make no guarantee about the accuracy, completeness, or fitness of any particular record. We do not guarantee sales, leads, or business outcomes. We are not affiliated with the MCA, GSTN or any government body.</p>
      <h2>8. Limitation of liability</h2>
      <p>To the maximum extent permitted by law, Registry Feed's total liability for any claim relating to the Service is capped at the fees you paid us in the three months preceding the claim.</p>
      <h2>9. Termination</h2>
      <p>We may suspend or terminate accounts that violate these terms. Refunds, if any, are governed by our <a href="/refund-policy">Refund Policy</a>.</p>
      <h2>10. Governing law</h2>
      <p>These terms are governed by the laws of India. Disputes are subject to the exclusive jurisdiction of the competent courts in India.</p>
      <h2>11. Contact</h2>
      <p>For any questions, email <a href={`mailto:${SITE.salesEmail}`}>{SITE.salesEmail}</a>.</p>
    </LegalPage>
  );
}
